import React, { useState, useEffect } from 'react';
import api from '../../services/api';
import Button from '../../components/button/button_v2';
import InputV2 from '../../components/input/input_v2';
import { store } from 'react-notifications-component';
import identifyErrorMenssage from '../../services/identifyErrorMenssage';
import { IntegracaoContainer, Title, Text } from './styles';
import logoomie from '../../assets/logos/omie.png';
import ModalGenericV2 from '../../components/modal/modalGenericV2';
import { H5, BodyG } from '../../styles/stylesTypography';

const WEBHOOK_BASE = `${(process.env.REACT_APP_API_HOST || '').replace(/\/$/, '')}/omie/webhook/`;
const OMIE_DEVELOPER_PORTAL_URL = 'https://developer.omie.com.br/my-apps/';

const TUTORIAL_VIDEO_URL = 'https://sudeste-online.s3.us-east-1.amazonaws.com/uploads/tutorial_omie.mp4';

const OmieConfig = () => {
    const [loading, setLoading] = useState(true);
    const [saving, setSaving] = useState(false);
    const [configurado, setConfigurado] = useState(false);
    const [webhookUrl, setWebhookUrl] = useState('');
    const [appKey, setAppKey] = useState('');
    const [appSecret, setAppSecret] = useState('');
    const [copied, setCopied] = useState(false);
    const [showTutorial, setShowTutorial] = useState(false);

    const loadConfig = async () => {
        try {
            const response = await api.get('/omie/config');
            const data = response.data;

            if (data.webhook_token) {
                setWebhookUrl(WEBHOOK_BASE + data.webhook_token);
            }

            if (data.configurado) {
                setConfigurado(true);
                setAppKey(data.app_key || '');
                setAppSecret(data.app_secret || '');
            }
        } catch (error) {
            // mantém estado inicial
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        loadConfig();
    }, []);

    const handleCopy = () => {
        navigator.clipboard.writeText(webhookUrl).then(() => {
            setCopied(true);
            setTimeout(() => setCopied(false), 2000);
        });
    };

    const handleSave = async () => {
        if (!appKey || !appSecret) {
            store.addNotification({
                title: 'Atenção!',
                message: 'Informe o App Key e o App Secret da Omie.',
                type: 'warning',
                insert: 'top',
                container: 'top-right',
                animationIn: ['animated', 'fadeIn'],
                animationOut: ['animated', 'fadeOut'],
                dismiss: { duration: 4000, onScreen: true },
            });
            return;
        }

        setSaving(true);
        try {
            const response = await api.post('/omie/config', { app_key: appKey, app_secret: appSecret });
            const data = response.data;

            // 1º toast: a configuração em si foi salva no banco.
            store.addNotification({
                title: 'Sucesso!',
                message: 'Configuração Omie salva com sucesso!',
                type: 'success',
                insert: 'top',
                container: 'top-right',
                animationIn: ['animated', 'fadeIn'],
                animationOut: ['animated', 'fadeOut'],
                dismiss: { duration: 4000, onScreen: true },
            });

            // 2º toast: resultado da validação/sincronização com a Omie.
            if (data.validado) {
                store.addNotification({
                    title: 'Sincronização com sucesso!',
                    message: 'Credenciais validadas com a Omie.',
                    type: 'success',
                    insert: 'top',
                    container: 'top-right',
                    animationIn: ['animated', 'fadeIn'],
                    animationOut: ['animated', 'fadeOut'],
                    dismiss: { duration: 4000, onScreen: true },
                });
            } else {
                store.addNotification({
                    title: 'Erro na sincronização',
                    message: data.erro_validacao || 'Não foi possível validar as credenciais com a Omie.',
                    type: 'danger',
                    insert: 'top',
                    container: 'top-right',
                    animationIn: ['animated', 'fadeIn'],
                    animationOut: ['animated', 'fadeOut'],
                    dismiss: { duration: 6000, onScreen: true },
                });
            }

            await loadConfig();
        } catch (error) {
            store.addNotification({
                title: 'Erro!',
                message: identifyErrorMenssage(error),
                type: 'danger',
                insert: 'top',
                container: 'top-right',
                animationIn: ['animated', 'fadeIn'],
                animationOut: ['animated', 'fadeOut'],
                dismiss: { duration: 4000, onScreen: true },
            });
        } finally {
            setSaving(false);
        }
    };

    if (loading) {
        return <IntegracaoContainer><Text>Carregando...</Text></IntegracaoContainer>;
    }

    return (
        <IntegracaoContainer>
            <img src={logoomie} alt="Omie" style={{ width: 120, marginBottom: 8 }} />

            <Title>Integração com a Omie</Title>
            <Text style={{ textAlign: 'center', maxWidth: 480 }}>
                Configure sua conta Omie para que os pedidos de venda sejam convertidos automaticamente em solicitação de receita no AgroReceita.<br></br>
                <span
                    onClick={() => setShowTutorial(true)}
                    style={{ color: '#589bff', fontWeight: 'bold', cursor: 'pointer' }}
                >
                    Veja o tutorial
                </span>
            </Text>

            {/* URL do webhook */}
            <div style={{ width: '100%', maxWidth: 480, marginTop: 24 ,marginBottom:25}}>
                <Text style={{ fontWeight: 'bold', marginBottom: 6, display: 'block' }}>
                    URL do Webhook (cole no painel Omie)
                </Text>
                <div style={{
                    display: 'flex',
                    alignItems: 'center',
                    gap: 8,
                    background: '#f4f6f8',
                    border: '1px solid #dce1e7',
                    borderRadius: 8,
                    padding: '10px 14px',
                }}>
                    <span style={{
                        flex: 1,
                        fontFamily: 'monospace',
                        fontSize: 12,
                        wordBreak: 'break-all',
                        color: '#303848',
                    }}>
                        {webhookUrl || '—'}
                    </span>
                    <button
                        onClick={handleCopy}
                        disabled={!webhookUrl}
                        style={{
                            background: 'none',
                            border: 'none',
                            cursor: webhookUrl ? 'pointer' : 'default',
                            color: copied ? '#21c55d' : '#589bff',
                            fontWeight: 'bold',
                            fontSize: 13,
                            whiteSpace: 'nowrap',
                            padding: '0 4px',
                        }}
                    >
                        {copied ? '✓ Copiado' : 'Copiar'}
                    </button>
                </div>

            </div>

            {/* Formulário */}
            <div style={{ width: '100%', maxWidth: 480, marginTop: 24, display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                <InputV2
                    label="App Key"
                    value={appKey}
                    onChange={(e) => setAppKey(e)}
                // placeholder="Informe o App Key da Omie"
                />

                <InputV2
                    label="App Secret"
                    value={appSecret}
                    onChange={(e) => setAppSecret(e)}
                />

                <Button
                    width="296px"
                    height="50px"
                    value={saving ? 'SALVANDO...' : 'SALVAR CONFIGURAÇÃO'}
                    outline={false}
                    disabled={saving}
                    onClick={handleSave}
                    loading={saving}
                />
            </div>

            <ModalGenericV2
                show={showTutorial}
                onHide={() => setShowTutorial(false)}
                marginBottom="0"
                width="70%"
            >
                <div style={{ padding: 24, width: '100%' }}>
                    <H5>Como ativar o webhook no painel Omie</H5>

                    <BodyG style={{ marginTop: 8, marginBottom: 16, whiteSpace: 'nowrap' }}>
                        Acesse o{' '}
                        <a
                            href={OMIE_DEVELOPER_PORTAL_URL}
                            target="_blank"
                            rel="noopener noreferrer"
                            style={{ color: '#589bff', fontWeight: 'bold' }}
                        >
                            portal do desenvolvedor da Omie
                        </a>{' '}
                        e siga o tutorial abaixo.
                    </BodyG>

                    {TUTORIAL_VIDEO_URL ? (
                        <video
                            src={TUTORIAL_VIDEO_URL}
                            controls
                            style={{
                                maxWidth: '100%',
                                maxHeight: '60vh',
                                borderRadius: 8,
                            }}
                        />
                    ) : (
                        <Text>Vídeo do tutorial em breve.</Text>
                    )}
                </div>
            </ModalGenericV2>
        </IntegracaoContainer>
    );
};

export default OmieConfig;
